// Modal.js
import React from 'react';
import './Modal.css';
import { useI18n } from '../i18n/I18nContext';

const Modal = ({
  title,
  message,
  children,
  onClose,
  primaryAction,
  secondaryAction,
}) => {
  const { t } = useI18n();
  if (!message) return null;

  const renderAction = (action, className) => {
    if (!action) return null;
    return (
      <button type="button" className={className} onClick={action.onClick}>
        {action.label}
      </button>
    );
  };

  return (
    <div className="modal" role="dialog" aria-modal="true" aria-label={title || message}>
      <div className="modal-content">
        <button type="button" className="close-button" onClick={onClose} aria-label={t('modal.close')}>&times;</button>
        {title ? <h2>{title}</h2> : null}
        <p>{message}</p>
        {children}
        {(primaryAction || secondaryAction) ? (
          <div className="modal-actions">
            {renderAction(secondaryAction, "modal-secondary-action")}
            {renderAction(primaryAction, "modal-primary-action")}
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default Modal;
